import { h } from 'preact';
import PropTypes from 'prop-types';

const Overlay = ({ show = true }) => show && <div className="c-overlay" />;

Overlay.propTypes = {
  show: PropTypes.bool,
};

export default Overlay;
